//@ts-strict-ignore
import React from 'react';
import Workspace from '../../components/Workspace/Workspace';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import CompanyUserNotification from '../../graphql/entities/company/CompanyUserNotification';
import { Direction, ICompanyUserNotification } from '../../graphql/schema/p4types';
import { Paths } from '../../@types/keyOfNested';

const USER_NOTIFICATION_FIELD_NAMES: Array<Paths<ICompanyUserNotification>> = [
  'companyUser.name',
  'title',
  'message',
  'alertType',
];

const UserNotificationWorkspace = (props) => {
  const workspaceProps = useWorkspace<ICompanyUserNotification>(props, CompanyUserNotification, {
    columns: USER_NOTIFICATION_FIELD_NAMES,
    initialSortColumn: 'createdAt',
    initialSortDirection: Direction.Desc,
  });

  return (
    <Workspace
      entityType={CompanyUserNotification.type}
      title={CompanyUserNotification.title}
      defaultQuery={CompanyUserNotification.workspace}
      {...props}
      {...workspaceProps}
      entity={CompanyUserNotification}
    />
  );
};

export default UserNotificationWorkspace;
